import { Box } from '@mui/material';
import { useIntl } from 'react-intl';

import {
  Dialog,
  DialogTitle,
  DialogMessageBox,
  DialogButtons,
} from '@verantos-dev/shared-components';

export type AppHeaderLogoutConfirmDialogProps = {
  onClose: () => void;
  onLogout: () => void;
};

export const AppHeaderLogoutConfirmDialog = (props: AppHeaderLogoutConfirmDialogProps) => {
  const { onClose, onLogout } = props;

  const intl = useIntl();

  return (
    <Dialog
      id="aappHeader-confirmLogout-dialog"
      //title={intl.formatMessage({ id: 'appHeader.confirmLogoutDialog.title' })}
      open={true}
      PaperProps={{
        sx: { width: '600px', maxHeight: '80%', margin: 0 },
      }}
      onClose={onClose}
      onSubmit={onLogout}
    >
      <DialogTitle id="appHeader.confirmLogoutDialog.title" showClose onClose={onClose}>
        {'Log out'}
      </DialogTitle>
      <Box sx={{ px: 6 }}>
        <DialogMessageBox
          id="appHeader-confirmLogout-dialog-message"
          type="info"
          title={intl.formatMessage({ id: 'appHeader.confirmLogoutDialog.message.title' })}
          text={intl.formatMessage({ id: 'appHeader.confirmLogoutDialog.message' })}
        />
      </Box>
      <DialogButtons
        id="appHeader-confirmLogout-dialog-buttons"
        cancelButton={{
          label: intl.formatMessage({ id: 'appHeader.confirmLogoutDialog.cancelButton.label' }),
          onClick: onClose,
        }}
        saveButton={{
          label: intl.formatMessage({ id: 'appHeader.confirmLogoutDialog.saveButton.label' }),
          onClick: onLogout,
        }}
      />
    </Dialog>
  );
};
